export const dataDefault = [{
    name: 'Occupancy% 出租率',
    actual: '0',
    budget: '0',
    lastYear: '0',
    score: ""
}, {
    name: 'Average RM Rate 平均房价',
    actual: '0',
    budget: '0',
    lastYear: '0',
    score: ""
}, {
    name: 'Revpar',
    actual: '0',
    budget: '0',
    lastYear: '0',
    score: ""
}, {
    name: 'Rooms Revenue 客房收入',
    actual: '0',
    budget: '0',
    lastYear: '0',
    score: ""
}, {
    name: 'Food & Beverage 餐饮收入',
    actual: '0',
    budget: '0',
    lastYear: '0',
    score: ""
}, {
    name: 'Other Revenue 其他收入',
    actual: '0',
    budget: '0',
    lastYear: '0',
    score: ""
}, {
    name: 'Grand Total 总计',
    actual: '0',
    budget: '0',
    lastYear: '0',
    score: ""
}];

export const columnsData = [
    {
        title: "-",
        key: "name",
        type: "text"
    }, {
        title: "M.T.D. 本月累计",
        children: [
            {
                title: "Actual 实际",
                key: "actual",
                type: "inputNumber"
            }, {
                title: "Budget 预算",
                key: "budget",
                type: "inputNumber"
            }, {
                title: "Last Year 去年同期",
                key: "lastYear",
                type: "inputNumber"
            }
        ]
    }
];

export const WeekColumnsData = [
    {
        title: "-",
        key: "name",
        type: "text"
    }, {
        title: "Current Week 本周",
        children: [
            {
                title: "Actual 实际",
                key: "week_actual",
                type: "inputNumber"
            }, {
                title: "Budget 预算",
                key: "week_budget",
                type: "inputNumber"
            }, {
                title: "Last Year 去年同期",
                key: "week_lastYear",
                type: "inputNumber"
            }
        ]
    }, {
        title: "M.T.D. 本月累计",
        children: [
            {
                title: "Actual 实际",
                key: "actual",
                type: "inputNumber"
            }, {
                title: "Budget 预算",
                key: "budget",
                type: "inputNumber"
            }, {
                title: "Last Year 去年同期",
                key: "lastYear",
                type: "inputNumber"
            }
        ]
    }
];


// WEBPACK FOOTER //
// ./src/components/table/meetingFlash/data.js